module.exports = __webpack_public_path__ + "static/media/02dec1918.909cbf3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/02dec1918.png
// module id = 1671
// module chunks = 0